export default __webpack_public_path__ + "static/media/c11.2895a585.jpg";